import { LandingPageTheme, MenuLayout } from 'api/landingPageTheme'
import { useEffect, useState } from 'react'
import useMenuLayoutEnabled from './useMenuLayoutEnabled'

const DEFAULT_MENU_LAYOUT: MenuLayout = 'tabs'

export function useMenuLayout(landingPageTheme: LandingPageTheme | null) {
  const enabled = useMenuLayoutEnabled()
  const themeId = landingPageTheme?.id ?? null
  const hasTheme = themeId !== null
  const [pending, setPending] = useState<{
    themeId: number
    layout: MenuLayout
  } | null>(null)

  const pendingLayout = pending?.themeId === themeId ? pending.layout : null
  const savedLayout =
    landingPageTheme?.settings.menu_layout ?? DEFAULT_MENU_LAYOUT
  const selectedLayout = pendingLayout ?? savedLayout

  useEffect(() => {
    if (pending && pending.layout === savedLayout) setPending(null)
  }, [pending, savedLayout])

  return {
    enabled,
    hasTheme,
    selectedLayout,
    setSelectedLayout: (layout: MenuLayout) => {
      if (themeId !== null) setPending({ themeId, layout })
    },
  }
}

export type MenuLayoutState = ReturnType<typeof useMenuLayout>
